export default __webpack_public_path__ + "assets/0a66f6801121b55bff131de33f12be37.jpg";